<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="规则编号" prop="id">
        <el-input v-model="searchData.id" placeholder="请输入" allowClear @input="handleIdInput"></el-input>
      </el-form-item>

      <el-form-item label="省" prop="provinceId">
        <el-select v-model="searchData.provinceId" placeholder="请选择" clearable style="width: 100%" @change="provinceChangeFun">
          <el-option v-for="item in provinceListNew" :key="item.provinceId" :label="item.province" :value="item.provinceId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityId">
        <el-select v-model="searchData.cityId" placeholder="请选择" clearable style="width: 100%" @change="cityChangeFun" :disabled="!searchData.provinceId">
          <el-option v-for="item in cityListNew" :key="item.cityId" :label="item.city" :value="item.cityId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区" prop="countyId">
        <el-select v-model="searchData.countyId" placeholder="请选择" clearable style="width: 100%" @change="countyChangeFun" :disabled="!searchData.cityId">
          <el-option v-for="item in districtListNew" :key="item.countyId" :label="item.county" :value="item.countyId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="旧机规格" prop="specifications">
        <el-select v-model="searchData.specifications" placeholder="请选择" clearable>
          <el-option v-for="item in oldMachineEnum" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="btn-group">
      <div class="row-bg">
        <el-button size="medium" @click="importOrder">批量更新</el-button>
        <el-button ghost size="medium" @click="exportBtnFun" :loading="exportFlag">导出</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="操作" prop="action" width="160">
        <template slot-scope="scope">
          <el-link type="primary" @click="openPriceUpdateModal(scope.row)">修改</el-link>
        </template>
      </el-table-column>
      <el-table-column label="规则编号" prop="id" min-width="100"></el-table-column>
      <el-table-column label="省" prop="province" min-width="100"></el-table-column>
      <el-table-column label="市" prop="city" min-width="100"></el-table-column>
      <el-table-column label="区" prop="county" min-width="100"></el-table-column>
      <el-table-column label="旧机规格" prop="specifications" min-width="200"></el-table-column>
      <el-table-column label="回收价格" prop="price" min-width="100"></el-table-column>
      <el-table-column label="更新时间" prop="lastModifiedDate" min-width="220"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog title="批量更新" :visible.sync="dialogVisible" width="400px" top="32vh" center>
      <div>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">下载excel模版</el-col>
          <el-col :span="8">
            <el-button type="primary" @click="download()">
              <div class="btnclass">
                <img src="@/assets/download.png" alt="" />
                <span>excel模版下载</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">导入excel</el-col>
          <el-col :span="8">
            <file-upload ref="Defaultfileupload" @addUpload="importUpdateDefaultByExcel" @removeUpload="removueFile" :title="'+导入excel文件'" :limit="1" v-if="Default" />
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="dialogVisible = false">取 消</div>
        <div @click="submitExcel()">确认导入</div>
      </div>
    </el-dialog>
    <price-update-modal ref="priceUpdateModalRef" @submit="getList()" @getList="getList()"></price-update-modal>
  </div>
</template>
<script>
import jdProvinceCity from '@/views/jdOldMachineRecycleManage/mixins/jdProvinceCity.js'
import FileUpload from '@/components/Upload/fileUpload'
import PriceUpdateModal from './components/PriceUpdateModal.vue'
import { getList } from '@/api/table'
import dayjs from 'dayjs'
export default {
  mixins: [jdProvinceCity],
  components: {
    FileUpload,
    PriceUpdateModal
  },
  data() {
    return {
      // 查询数据
      searchData: {
        id: undefined,
        provinceId: undefined,
        cityId: undefined,
        countyId: undefined,
        specifications: undefined //规格
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        rows: 10
      },
      total: 0,
      selectList: [],
      exportFlag: false,
      createTime: [],
      completeTime: [],
      provinceList: [],
      cityList: [],
      dialogVisible: false,
      defaultLoading: false,
      Default: true,
      defaultUpLoadData: {},
      oldMachineEnum: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        setTimeout(() => {
          if (!this.global.handleEmptyData(this.defaultUpLoadData)) {
            this.$refs.Defaultfileupload.$refs.upload.clearFiles()
          }
          this.defaultUpLoadData = {}
          this.Default = true
        }, 100)
      }
    }
  },
  mounted() {
    this.getList(), this.provinceChangeFun(), this.getOldMachineEnum()
  },
  methods: {
    // 获取分页数据
    getList() {
      const url = `/autoapp-default-server-recovery/api/settlement/jdPrice/pageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      return this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode === 200) {
          this.total = res.data.total || 0
          const resData = res.data.records || []
          this.tableData = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 清空
    resetForm() {
      // 重置搜索条件
      Object.assign(this.searchData, {
        id: undefined,
        provinceId: undefined,
        province: undefined,
        city: undefined,
        cityId: undefined,
        county: undefined,
        countyId: undefined,
        specifications: undefined //规格
      })

      this.getList()
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 导出
    exportBtnFun() {
      this.exportFlag = true
      setTimeout(() => {
        this.exportFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/settlement/jdPrice/exportPageCondition'
      const title = '价格配置数据(京东)'
      const params = {
        ...this.searchData
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    // 省改变
    provinceChangeFun() {
      this.searchData.cityId = undefined
      this.searchData.countyId = undefined
      const selectedProvince = this.provinceListNew.find(item => item.provinceId === this.searchData.provinceId)
      this.searchData.province = selectedProvince ? selectedProvince.province : undefined
      this.getTblCityNew(this.searchData.provinceId)
    },
    // 市改变
    cityChangeFun() {
      this.searchData.countyId = undefined
      const selectedCity = this.cityListNew.find(item => item.cityId === this.searchData.cityId)
      this.searchData.city = selectedCity ? selectedCity.city : undefined
      this.getTblCountyNew(this.searchData.provinceId, this.searchData.cityId)
    },
    // 区县改变
    countyChangeFun() {
      const selectedCounty = this.districtListNew.find(item => item.countyId === this.searchData.countyId)
      this.searchData.county = selectedCounty ? selectedCounty.county : undefined
    },

    importOrder() {
      this.dialogVisible = true
    },

    //普通订单
    importUpdateDefaultByExcel(item) {
      this.defaultLoading = true
      this.defaultUpLoadData = item
    },

    removueFile() {
      this.Default = true
      this.defaultUpLoadData = {}
    },

    download() {
      this.global.exportExcel('/autoapp-default-server-recovery/api/settlement/jdPrice/downloadTemplate', {}, '价格配置(京东)更新模版').catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    openPriceUpdateModal(row) {
      const { id } = row
      this.$refs.priceUpdateModalRef.openDialog(row)
    },
    submitExcel() {
      if (this.global.handleEmptyData(this.defaultUpLoadData)) {
        this.$message.error('请上传文件')
      } else {
        // 添加全局loading
        const loading = this.$loading({
          lock: true,
          text: '数据导入中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        let formData = new FormData()
        if (!this.global.handleEmptyData(this.defaultUpLoadData)) {
          formData.append('file', this.defaultUpLoadData.file)
          this.HttpService.post('/autoapp-default-server-recovery/api/settlement/jdPrice/importData', formData).then(res => {
            // 关闭loading
            loading.close();

            if (res.statusCode !== 200) {
              return this.$message.error(res.message)
            }
            if (res.data != null) {
              this.$message.error('文件有误, 请查看错误报告')
              this.getErrorReport(res.data)
            } else {
              this.$message.success('导入成功')
              this.dialogVisible = false
              this.getList()
            }
          }).catch(error => {
            // 异常时关闭loading
            loading.close();
            this.$message.error('导入失败');
          })
        } else {
          // 关闭loading
          loading.close();
        }
        this.dialogVisible = false
      }
    },
    getOldMachineEnum() {
      this.HttpService.get('/autoapp-default-server-recovery/api/settlement/jdPrice/getSpecificationsList').then(res => {
        if (res.statusCode === 200) {
          this.oldMachineEnum = res.data
        }
      })
    },
    getErrorReport(downLoadId) {
      const url = `/autoapp-default-server-recovery/api/file/downLoadFailById`
      this.global.exportExcel(url, { downId: downLoadId }, '错误文件').catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    handleIdInput(value) {
      this.searchData.id = value.replace(/[^0-9]/g, '')
    }
  }
}
</script>
<style scoped lang="scss">
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.btnclass {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settlementManagement/priceConfigurationJD.vue